/**
 * Which School Management tab to show when the user lacks access to it.
 *
 * Documents and Frameworks need the school admin's own school. Access is
 * only known once the school has loaded: deciding earlier sent every
 * `?tab=documents` link (and a reload on that tab) back to Overview.
 */
export type SchoolTab =
  | 'overview'
  | 'students'
  | 'cohorts'
  | 'engagements'
  | 'mentors'
  | 'documents'
  | 'frameworks'
  | 'settings';

const PRIVATE_KNOWLEDGE_TABS: readonly SchoolTab[] = ['documents', 'frameworks'];

export function restrictedTabFallback(
  tab: SchoolTab,
  { canAccessPrivateSchoolKnowledge, schoolLoading }: { canAccessPrivateSchoolKnowledge: boolean; schoolLoading: boolean },
): SchoolTab | null {
  if (schoolLoading || canAccessPrivateSchoolKnowledge) return null;
  return PRIVATE_KNOWLEDGE_TABS.includes(tab) ? 'overview' : null;
}
